import { get, put, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function loadPartnerIncomeTypes(documentId, siteId, partnerId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/partner/${partnerId}/incometypes`);
}

export function updateOfferPartnerIncomeType(data) {
  return put(url + `/leasingoffers/${data.documentId}/${data.siteId}/partner/${data.partnerId}/incometype`, data);
}

export function updateOfferAssociatedPartnerIncomeType(data) {
  return post(
    url + `/leasingoffers/${data.documentId}/${data.siteId}/associatedpartner/${data.partnerId}/incometype`,
    data
  );
}

export function loadPartnerIncomeTypeData(documentId, siteId, partnerId, incomeTypeId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/partner/${partnerId}/incomedata/${incomeTypeId}`);
}

export function loadPartnerSalaryData(documentId, siteId, incomeTypeId, partnerId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/partner/${partnerId}/salarydata/${incomeTypeId}`);
}

export function loadIncomeDataDetailOptions(detailId) {
  return get(url + `/incomedata/${detailId}/options`);
}

export function loadAssociatedPartnerIncomeTypeSalaryData(documentId, siteId, partnerId, incomeTypeId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/associatedpartner/${partnerId}/salarydata/${incomeTypeId}`);
}

export function updatePartnerIncomeData(data) {
  return post(url + `/leasingoffers/${data.documentId}/${data.siteId}/incomedata`, data);
}

export function updateOfferAssociatedPartnerIncomeData(data) {
  return post(
    url +
      `/leasingoffers/${data.documentId}/${data.siteId}/associatedpartner/${data.partnerId}/incomedata/${data.incomeTypeId}`,
    data
  );
}

export function updatePartnerSalaryData(data) {
  return post(url + `/leasingoffers/${data.documentId}/${data.siteId}/salarydata`, data);
}

export function updateOfferAssociatedPartnerSalaryData(data) {
  return post(
    url +
      `/leasingoffers/${data.documentId}/${data.siteId}/associatedpartner/${data.partnerId}/salarydata/${data.incomeTypeId}`,
    data
  );
}
